import { IBiz } from './biz'
import { IQueryParams, IPagination } from './common'

// ç»ç«¯åè¡¨æ¥è¯¢åæ°
export interface ITerminalQueryParams extends IQueryParams, IBiz {
  /*
    åå»ºæ¶é´
    ç»ç«¯ç¼å·
    ç»ç«¯ç¶æ
    é¨åºç¼å·
    é¨åºåç§°
    æºæç¼å·
    æºæåç§°
    éå¢ç¼å·
    éå¢åç§°
    åæ·ç¼å·
    åæ·åç§°
  */
  termCode?: string
  terminalStatus?: ITerminalStatus
  storeNum?: string
  storeName?: string

  /** ç¨äºæ¥è¯¢æ¥è¡¨ä½¿ç¨  */
  intStoreCode?: string
}

// ç»ç«¯ç¶æåè¡¨
export enum ITerminalStatus {
  Init = 'init', // åå§å
  Normal = 'normal', // æ­£å¸¸
  Freeze = 'freeze', // å»ç»
}

export class Manual {
  termCode: string
}

// ç»ç«¯ä¿¡æ¯
export class Terminal {
  id?: string // å¯ä¸ç´¢å¼
  common: TerminalCommon
  qr: TerminalQR
  emvPans: IEmvPans

  /** æ°æ¥å£ */
  version: number

  createdAt: string
  updatedAt: string

  constructor() {
    this.common = new TerminalCommon()
    this.qr = new TerminalQR()
  }
}

export class TerminalCommon {
  insCode: string // æºæç¼å·
  insName: string // æºæåç§°
  insNameEN: string // æºæè±æåç§°
  agentCode: string // éå¢ç¼å·
  agentName: string // éå¢åç§°
  agentNameEN: string // éå¢è±æåç§°
  intMerCode: string // åé¨åæ·å·
  merNum: string // åæ·å·
  merName: string // åæ·åç§°
  merNameEN: string // åæ·è±æåç§°
  intStoreCode: string // åé¨é¨åºå·
  storeNum: string // é¨åºç¼å·
  storeName: string // é¨åºåç§°
  storeNameEN: string // é¨åºè±æåç§°
  status: ITerminalStatus // ç¶æ
  termCode: string // ç»ç«¯ç¼å·
  remark: string // å¤æ³¨
  termVendar: ETermVendar // ç»ç«¯åå

  cdKey: string // æ¿æ´»ç 
  // qrCodeURL: string // æ¯ä»å®ãå¾®ä¿¡ç­ URL ç±»åçäºç»´ç æ°æ®
  // qrCodeEMV: string // é¶èãVISAç­EMVæ åçäºç»´ç æ°æ®
  wallets: string[]
  tradeTypes: string[]
  transCurr: string // å¸ç§
}

export enum ETermVendar {
  Newland = 'Newland',
  Landi = 'Landi',
  Pax = 'Pax',
  Sunmi = 'Sunmi',
}

export class TerminalQR {
  isAmountFixed = false
  fixedAmt: string
  qrCode: string
  qrCodeURL: string // æ¯ä»å®ãå¾®ä¿¡ç­ URL ç±»åçäºç»´ç æ°æ®
  qrCodeEMV: string // é¶èãVISAç­EMVæ åçäºç»´ç æ°æ®
  emvPaymentBrands: string[]
  urlPaymentBrands: string[]
}

export interface IEmvPans {
  upiPan: string
  visPan: string
  mccPan: string
  fpsPan?: string
}

export interface ITermPagination extends IPagination {
  data: Terminal[]
}

export class TerminalNewRequest {
  intStoreCode: string
  count: number
  termCodes: string[] = []
  isAmountFixed: boolean
  fixedAmt: number
  remark: string
  termVendar: ETermVendar

  mode?: number // æ°å¢è¿ç¨ä¸­ä½¿ç¨çåéï¼ä¸å¾åç«¯ä¼ 
  manuals?: string[] = []
  selectedStore?: any
  insCode?: string // æºæç¼å·
  insName?: string // æºæåç§°
  insNameEN?: string // æºæè±æåç§°
  agentCode?: string // éå¢ç¼å·
  agentName?: string // éå¢åç§°
  agentNameEN?: string // éå¢è±æåç§°
  intMerCode?: string // åé¨åæ·å·
  merNum?: string // åæ·å·
  merName?: string // åæ·åç§°
  merNameEN?: string // åæ·è±æåç§°
  storeNum?: string // é¨åºç¼å·
  storeName?: string // é¨åºåç§°
  storeNameEN?: string // é¨åºè±æåç§°
}

export interface ITerminalUpdateRequest {
  version: number
  common: {
    remark: string;
    termVendar: ETermVendar;
  }
  qr?: {
    isAmountFixed: boolean;
    fixedAmt: string;
  }
}

export interface ITerminalReportPagination {
  url: string
}
